module.exports = "/_next/static/images/9fc8deb47268b138e2132163d6b66d8c-receive.svg.webp";